/**
 * Angular dependencies
 */
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

/**
 * Third-party dependencies
 */
import { AutosizeModule } from 'ngx-autosize';
import { MarkdownModule } from 'ngx-markdown';

/**
 * App dependencies
 */
import { AskGeneNewComponent } from '@app/ask-gene-new/ask-gene-new.component';
import { AssistantMessageComponent } from '@app/chat-new/assistant-message/assistant-message.component';
import { ChatNewComponent } from '@app/chat-new/chat-new.component';
import { UserMessageComponent } from '@app/chat-new/user-message/user-message.component';
import { SavedPromptsComponent } from '@app/my-library/saved-prompts/saved-prompts.component';
import { PagedPromptsComponent } from '@app/paged-prompts/paged-prompts.component';
import { FormPromptComponent } from '@app/prompt/formprompt/form-prompt.component';
import { ModalEditPromptComponent } from '@app/prompt/modaleditprompt/modal-edit-prompt.component';
import { ModalSavePromptComponent } from '@app/prompt/modalsaveprompt/modal-save-prompt.component';
import { PublicPagedPromptsComponent } from '@app/public-paged-prompts/public-paged-prompts.component';
import { SharePromptComponent } from '@app/share-prompt/share-prompt.component';
import { ChatWrapperComponent } from '@app/shared/components/chat-wrapper/chat-wrapper.component';
import { CopyResponseComponent } from '@app/shared/components/copy-response/copy-response.component';
import { FileManagerModule } from '@app/shared/components/file-manager/file-manager.module';
import { ImageChipComponent } from '@app/shared/components/image-chip/image-chip.component';
import { ImageFileReferencesWrapperComponent } from '@app/shared/components/image-file-references-wrapper/image-file-references-wrapper.component';
import { ImageManagerComponent } from '@app/shared/components/image-manager/image-manager.component';
import { InputSelectBoxComponent } from '@app/shared/components/input-select-box/input-select-box.component';
import { MarkdownWrapperComponent } from '@app/shared/components/markdown-wrapper/markdown-wrapper.component';
import { PromptInputNewComponent } from '@app/shared/components/prompt-input-new/prompt-input-new.component';
import { PromptInputPreviewImagesComponent } from '@app/shared/components/prompt-input-preview-images/prompt-input-preview-images.component';
import { PromptInputComponent } from '@app/shared/components/prompt-input/prompt-input.component';
import { ReferenceDrawerItemComponent } from '@app/shared/components/reference-drawer/reference-drawer-item/reference-drawer-item.component';
import { ReferenceDrawerComponent } from '@app/shared/components/reference-drawer/reference-drawer.component';
import { WebSearchToggleComponent } from '@app/shared/components/web-search-toggle/web-search-toggle.component';
import { GeneAiUiModule } from '@gene-ai/ui/gene-ai-ui.module';
import { PromptSettingsNewComponent } from '@shared/components/prompt-settings-new/prompt-settings-new.component';
import { PromptSettingsComponent } from '@shared/components/prompt-settings/prompt-settings.component';
import { SharedModule } from '@shared/shared.module';
import { ChatImageMessagesComponent } from './chat-image-messages/chat-image-messages.component';
import { ChatComponent } from './chat.component';
import { RouterModule } from '@angular/router';


@NgModule({
  declarations: [
    AskGeneNewComponent,
    AssistantMessageComponent,
    ChatComponent,
    ChatImageMessagesComponent,
    ChatNewComponent,
    ChatWrapperComponent,
    CopyResponseComponent,
    FormPromptComponent,
    ImageChipComponent,
    ImageFileReferencesWrapperComponent,
    ImageManagerComponent,
    InputSelectBoxComponent,
    MarkdownWrapperComponent,
    ModalEditPromptComponent,
    ModalSavePromptComponent,
    PagedPromptsComponent,
    PublicPagedPromptsComponent,
    PromptInputComponent,
    PromptInputNewComponent,
    PromptInputPreviewImagesComponent,
    PromptSettingsComponent,
    PromptSettingsNewComponent,
    ReferenceDrawerComponent,
    ReferenceDrawerItemComponent,
    SavedPromptsComponent,
    SharePromptComponent,
    UserMessageComponent,
    WebSearchToggleComponent
  ],
  exports: [
    AskGeneNewComponent,
    AssistantMessageComponent,
    ChatComponent,
    ChatNewComponent,
    ChatWrapperComponent,
    CopyResponseComponent,
    FormPromptComponent,
    MarkdownWrapperComponent,
    PromptInputComponent,
    PromptInputNewComponent,
    PromptSettingsComponent,
    PromptSettingsNewComponent,
    SavedPromptsComponent,
    UserMessageComponent,
    WebSearchToggleComponent,
  ],
  imports: [
    AutosizeModule,
    CommonModule,
    FileManagerModule,
    FormsModule,
    GeneAiUiModule,
    MarkdownModule.forChild(),
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
})
export class ChatModule { }
